//  初始化google analysis
const IS_INLAND = document.domain === 'h5.upliveapp.com';
if (!IS_INLAND) {
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.onload = () => {
            $.channel.emit('analyticsSeedLoaded');
        };
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    ga('create', 'UA-80499728-13', 'auto');
}

//  初始化mixpanel
(function (e, a) {
    if (!a.__SV) {
        var b = window;
        try {
            var c, l, i, j = b.location, g = j.hash;
            c = function (a, b) {
                return (l = a.match(RegExp(b + "=([^&]*)"))) ? l[1] : null
            };
            g && c(g, "state") && (i = JSON.parse(decodeURIComponent(c(g, "state"))), "mpeditor" === i.action && (b.sessionStorage.setItem("_mpcehash", g), history.replaceState(i.desiredHash || "", e.title, j.pathname + j.search)))
        } catch (m) {
        }
        var k, h;
        window.mixpanel = a;
        a._i = [];
        a.init = function (b, c, f) {
            function e(b, a) {
                var c = a.split(".");
                2 == c.length && (b = b[c[0]], a = c[1]);
                b[a] = function () {
                    b.push([a].concat(Array.prototype.slice.call(arguments,
                        0)))
                }
            }

            var d = a;
            "undefined" !== typeof f ? d = a[f] = [] : f = "mixpanel";
            d.people = d.people || [];
            d.toString = function (b) {
                var a = "mixpanel";
                "mixpanel" !== f && (a += "." + f);
                b || (a += " (stub)");
                return a
            };
            d.people.toString = function () {
                return d.toString(1) + ".people (stub)"
            };
            k = "disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
            for (h = 0; h < k.length; h++) e(d, k[h]);
            a._i.push([b, c, f])
        };
        a.__SV = 1.2;
        b = e.createElement("script");
        b.type = "text/javascript";
        b.async = !0;
        b.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === e.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
        b.onload = () => {
            $.channel.emit('mixpanelLoaded');
        };
        c = e.getElementsByTagName("script")[0];
        c.parentNode.insertBefore(b, c)
    }
})(document, window.mixpanel || []);

//  全局GA
let GA = {
    // 用于存放JS尚未加载的缓存事件列表
    // js加载完成后，依次发送到对应服务
    cacheList: [],
    add(obj, data) {
        //  国内用户只会用到gio
        if ((IS_INLAND && window.minpanelReady) ||
            (!IS_INLAND && window.gaReady && window.minpanelReady)) {
            this._add(obj, data);
        } else {
            this.cacheList.push({name: obj, data: data});
        }
    },
    _add(obj, data) {
        if (!GAENABLE || UG.isStage) {
            return;
        }
        const name = typeof obj === 'string' ? obj : obj.eventName;
        if (window.gaReady) {
            ga('send', {
                hitType: 'event',
                eventCategory: name,
                eventAction: 'click'
            });
        }
        try {
            mixpanel.track(name, data || {});
        } catch (err) {
            //  gio 没有配置对应的字段
            console.error(`${err}`);
        }
    },
    addPreviousCache() {
        //  国内
        if ((IS_INLAND && window.minpanelReady)
            || (!IS_INLAND && window.gaReady && window.minpanelReady)) {
            this.cacheList.forEach(({name, data}, index) => {
                this._add(name, data);
            });
            this.cacheList = [];
        }
    }
};

// google
$.channel.on('analyticsSeedLoaded', () => {
    window.gaReady = true;
    console.log('analyticsSeedLoaded');
    GA.addPreviousCache();
});

$.channel.on('mixpanelLoaded', () => {
    window.minpanelReady = true;
    // TODO
    mixpanel.init("b5b2d95c83c6b7f5d7c260a855639506");
    console.log('mixpanelLoaded');
    GA.addPreviousCache();
});
window.GA = GA;
export default GA;



// WEBPACK FOOTER //
// ./js/lib/ga.js